// อ่าน "ประเทศผลิต" จากเอกสารของซัพ (packing list / invoice) → รหัส 2 ตัว (CN · VN · JP …)
// ที่มา (29 ต.ค. 69) user: "การ์ดใหม่ควรใช้แหล่งกำเนิดจากข้อมูลจริง"
//   เดิมใบข้อมูลสินค้าที่สร้างใหม่ได้ประเทศของ supplier ไปทั้งตู้ → ของจีน/เวียดนามที่ส่งจากญี่ปุ่นกลายเป็น JP
//   แล้วระบบขอ Form JTEPA ทั้งที่ใช้สิทธิ์ไม่ได้ · packing list ส่วนใหญ่มีคอลัมน์ Country of Origin ทุกบรรทัด = ข้อมูลจริง
//
// ⚠ อ่านไม่ออก = คืน null (ไม่เดา) — คนเห็นในหน้าตรวจว่าแถวไหนอ่านไม่ได้

// รหัส 2 ตัวที่รับตรง ๆ — รับเฉพาะที่รู้จัก กันคำอื่นที่บังเอิญยาว 2 ตัว (เช่น "NA" = ไม่ระบุ) กลายเป็นประเทศ
const KNOWN = new Set(('JP CN US VN KR TW TH DE IT FR GB IN ID MY SG AU NZ HK CH NL SE NO ES CA '
  + 'PH KH LA MM BD LK MX PT TR PK DK FI AT BE IE PL CZ').split(' '));

// [รหัส, ชื่อที่เจอในเอกสาร (อังกฤษตัวใหญ่ · ญี่ปุ่น · จีน · ไทย)]
const NAMES = [
  ['CN', ['CHINA', 'CHINA MAINLAND', 'MAINLAND CHINA', 'PRC', 'P R C', 'PR CHINA', 'P R CHINA', "PEOPLE'S REPUBLIC OF CHINA", 'PEOPLES REPUBLIC OF CHINA', '中国', '中國', 'จีน']],
  ['VN', ['VIETNAM', 'VIET NAM', 'VIET-NAM', 'ベトナム', '越南', 'เวียดนาม']],
  ['JP', ['JAPAN', '日本', 'ญี่ปุ่น']],
  ['TW', ['TAIWAN', 'TAIWAN ROC', 'TAIWAN R O C', 'ROC', '台湾', '台灣', 'ไต้หวัน']],
  ['KR', ['KOREA', 'SOUTH KOREA', 'REPUBLIC OF KOREA', 'KOREA REPUBLIC OF', 'KOREA (SOUTH)', '韓国', '韓國', 'เกาหลี', 'เกาหลีใต้']],
  ['TH', ['THAILAND', 'タイ', 'ไทย', 'ประเทศไทย']],
  ['US', ['USA', 'U S A', 'UNITED STATES', 'UNITED STATES OF AMERICA', 'AMERICA', 'アメリカ', '米国', 'สหรัฐอเมริกา', 'สหรัฐ', 'อเมริกา']],
  ['ID', ['INDONESIA', 'インドネシア', 'อินโดนีเซีย']],
  ['MY', ['MALAYSIA', 'マレーシア', 'มาเลเซีย']],
  ['PH', ['PHILIPPINES', 'フィリピン', 'ฟิลิปปินส์']],
  ['KH', ['CAMBODIA', 'カンボジア', 'กัมพูชา']],
  ['LA', ['LAOS', 'LAO PDR', 'ラオス', 'ลาว']],
  ['MM', ['MYANMAR', 'BURMA', 'ミャンマー', 'เมียนมา', 'พม่า']],
  ['IN', ['INDIA', 'インド', 'อินเดีย']],
  ['BD', ['BANGLADESH', 'バングラデシュ', 'บังกลาเทศ']],
  ['LK', ['SRI LANKA', 'スリランカ', 'ศรีลังกา']],
  ['PK', ['PAKISTAN', 'パキスタン', 'ปากีสถาน']],
  ['DE', ['GERMANY', 'ドイツ', 'เยอรมนี']],
  ['IT', ['ITALY', 'イタリア', 'อิตาลี']],
  ['FR', ['FRANCE', 'フランス', 'ฝรั่งเศส']],
  ['GB', ['UK', 'U K', 'UNITED KINGDOM', 'ENGLAND', 'GREAT BRITAIN', 'イギリス', 'สหราชอาณาจักร', 'อังกฤษ']],
  ['SE', ['SWEDEN', 'スウェーデン', 'สวีเดน']],
  ['NO', ['NORWAY', 'ノルウェー', 'นอร์เวย์']],
  ['ES', ['SPAIN', 'スペイン', 'สเปน']],
  ['PT', ['PORTUGAL', 'ポルトガル', 'โปรตุเกส']],
  ['CA', ['CANADA', 'カナダ', 'แคนาดา']],
  ['AU', ['AUSTRALIA', 'オーストラリア', 'ออสเตรเลีย']],
  ['NZ', ['NEW ZEALAND', 'ニュージーランド', 'นิวซีแลนด์']],
  ['HK', ['HONG KONG', '香港', 'ฮ่องกง']],
  ['SG', ['SINGAPORE', 'シンガポール', 'สิงคโปร์']],
  ['CH', ['SWITZERLAND', 'スイス', 'สวิตเซอร์แลนด์']],
  ['NL', ['NETHERLANDS', 'HOLLAND', 'オランダ', 'เนเธอร์แลนด์']],
  ['MX', ['MEXICO', 'メキシコ', 'เม็กซิโก']],
  ['TR', ['TURKEY', 'TURKIYE', 'トルコ', 'ตุรกี']],
];
const clean = (s) => s.toUpperCase().replace(/[.,]/g, ' ').replace(/\s+/g, ' ').trim();
const BY_NAME = new Map(NAMES.flatMap(([cc, ns]) => ns.map(n => [clean(n), cc])));

function one(s, allowCode) {
  const t = clean(s).replace(/^MADE IN:? /, '').replace(/^ORIGIN:? /, '')
    .replace(/(製|制|產|产)$/u, '').trim();                  // 中国製 · ベトナム製 · 中国产
  if (!t) return null;
  // ชื่อก่อนรหัส — "UK" เป็นชื่อเรียก ไม่ใช่รหัส ISO (รหัสจริงคือ GB)
  return BY_NAME.get(t) ?? (allowCode && /^[A-Z]{2}$/.test(t) && KNOWN.has(t) ? t : null);
}

// ข้อความในช่อง → รหัสประเทศ · อ่านไม่ออก/ว่าง = null
//   "CHINA" · "Made in China" · "P.R.C." · "中国製" · "CHINA(中国)" · "Viet Nam" · "JP" → CN · CN · CN · CN · CN · VN · JP
// allowCode = false → ไม่รับรหัส 2 ตัวเปล่า ๆ — ใช้ตอน "เดาว่าคอลัมน์ไหนคือประเทศ" เพราะรหัสสี/หน่วยชนกับรหัสประเทศ
//   (KH = khaki/กัมพูชา · PK = pink, pack/ปากีสถาน · BE = beige/เบลเยียม · NO = ไม่/นอร์เวย์ — รีวิว 29 ต.ค. 69)
export function toCountryCode(v, { allowCode = true } = {}) {
  const s = String(v ?? '').normalize('NFKC').trim();
  if (!s) return null;
  const direct = one(s, allowCode);
  if (direct) return direct;
  // "CHINA(中国)" / "中国 (CHINA)" — ลองทั้งนอกวงเล็บและในวงเล็บ ต้องได้ประเทศเดียวกันถึงจะรับ
  const inner = [...s.matchAll(/\(([^)]*)\)/g)].map(m => one(m[1], allowCode)).filter(Boolean);
  const outer = one(s.replace(/\([^)]*\)/g, ' '), allowCode);
  const all = [...new Set([outer, ...inner].filter(Boolean))];
  return all.length === 1 ? all[0] : null;
}

// หัวคอลัมน์ที่น่าจะเป็นประเทศผลิต — 2 = ชัด (Country of Origin · C/O · 原産国) · 1 = แค่ "Country"/"ประเทศ" · 0 = ไม่ใช่
//   ประเทศปลายทาง/ผู้รับ (Destination Country · Ship to · 仕向国) = 0 เสมอ — packing list มีทั้งสองคอลัมน์บ่อย
//   และปลายทางเป็น THAILAND ทุกแถว ถ้าเลือกผิดใบสินค้าจะกลายเป็น "ผลิตที่ไทย" ทั้งตู้ (รีวิวรอบสอง 29 ต.ค. 69)
export const isDestinationHeader = (h) =>
  /dest|(ship|sold|bill|deliver(ed)?)[\s\-_]*to\b|consign|deliver|import(er)?\b|buyer|仕向|納品|ปลายทาง|ผู้รับ|ผู้ซื้อ|ผู้นำเข้า/i.test(String(h ?? ''));
export function originHeaderLevel(h) {
  const s = String(h ?? '');
  if (isDestinationHeader(s)) return 0;
  if (/origin|c\s*\/\s*o\b|\bcoo\b|made\s*in|原産|生産国|製造国|产地|ถิ่นกำเนิด|แหล่งกำเนิด|ประเทศผลิต|ผลิตที่/i.test(s)) return 2;
  if (/country|ประเทศ/i.test(s)) return 1;
  return 0;
}
export const isOriginHeader = (h) => originHeaderLevel(h) > 0;
